package com.arenaproplay.admin.domain.me

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class FeedImage(
    @SerialName("id") val id: String,
    @SerialName("imageUrl") val imageUrl: String,
    @SerialName("sortOrder") val sortOrder: Int = 0,
)

@Serializable
data class FeedPost(
    @SerialName("id") val id: String,
    @SerialName("authorType") val authorType: String,
    @SerialName("authorId") val authorId: String,
    @SerialName("authorName") val authorName: String,
    @SerialName("authorAvatarUrl") val authorAvatarUrl: String? = null,
    @SerialName("content") val content: String,
    @SerialName("city") val city: String? = null,
    @SerialName("images") val images: List<FeedImage> = emptyList(),
    @SerialName("likesCount") val likesCount: Int = 0,
    @SerialName("isLikedByMe") val isLikedByMe: Boolean = false,
    @SerialName("commentsCount") val commentsCount: Int = 0,
    @SerialName("createdAt") val createdAt: String,
)

@Serializable
data class FeedPage(
    @SerialName("items") val items: List<FeedPost>,
    @SerialName("page") val page: Int,
    @SerialName("size") val size: Int,
    @SerialName("totalItems") val totalItems: Long,
    @SerialName("totalPages") val totalPages: Int,
)

@Serializable
data class ChatLastMessage(
    @SerialName("id") val id: String,
    @SerialName("senderUsername") val senderUsername: String? = null,
    @SerialName("content") val content: String = "",
    @SerialName("type") val type: String = "TEXT",
    @SerialName("createdAt") val createdAt: String = "",
)

@Serializable
data class ChatListItem(
    @SerialName("id") val id: String,
    @SerialName("type") val type: String,
    @SerialName("name") val name: String? = null,
    @SerialName("imageUrl") val imageUrl: String? = null,
    @SerialName("privacy") val privacy: String = "PRIVATE",
    @SerialName("lastMessage") val lastMessage: ChatLastMessage? = null,
    @SerialName("unreadCount") val unreadCount: Long = 0,
    @SerialName("isMuted") val isMuted: Boolean = false,
    @SerialName("otherUserId") val otherUserId: String? = null,
    @SerialName("createdAt") val createdAt: String,
)

/** One message of a chat's history (admin read-only view). */
@Serializable
data class ChatMessage(
    @SerialName("id") val id: String,
    @SerialName("senderId") val senderId: String = "",
    @SerialName("senderUsername") val senderUsername: String? = null,
    @SerialName("senderAvatarUrl") val senderAvatarUrl: String? = null,
    @SerialName("content") val content: String = "",
    @SerialName("type") val type: String = "TEXT",
    @SerialName("fileUrl") val fileUrl: String? = null,
    @SerialName("fileName") val fileName: String? = null,
    @SerialName("createdAt") val createdAt: String = "",
)

/** Newest-first page of chat history: page 1 = latest messages. */
@Serializable
data class ChatMessagesPage(
    @SerialName("messages") val messages: List<ChatMessage>,
    @SerialName("total") val total: Long,
    @SerialName("page") val page: Int,
    @SerialName("size") val size: Int,
) {
    val totalPages: Int
        get() = if (total == 0L) 1 else ((total + size - 1) / size).toInt()
}

@Serializable
data class ChatListPage(
    @SerialName("items") val items: List<ChatListItem>,
    @SerialName("page") val page: Int,
    @SerialName("size") val size: Int,
    @SerialName("totalItems") val totalItems: Long,
    @SerialName("totalPages") val totalPages: Int,
)
